import { forEach, filter, isFunction } from 'lodash'

const createEventEmitter = () => {
  const listeners = {}

  const on = (eventType, callback) => {
    if (!isFunction(callback)) {
      console.warn('EventEmitter: callback must be a function')
      return () => {}
    }

    if (!listeners[eventType]) {
      listeners[eventType] = []
    }

    listeners[eventType].push(callback)

    // Return unsubscribe function
    return () => {
      listeners[eventType] = filter(
        listeners[eventType],
        (cb) => cb !== callback
      )
    }
  }

  const emit = (eventType, data) => {
    const eventListeners = listeners[eventType] || []
    forEach(eventListeners, (callback) => {
      try {
        callback(data)
      } catch (error) {
        console.error(`EventEmitter: Error in listener for ${eventType}:`, error)
      }
    })

    // Also emit to wildcard listeners
    const wildcardListeners = listeners['*'] || []
    forEach(wildcardListeners, (callback) => {
      try {
        callback({ type: eventType, data })
      } catch (error) {
        console.error('EventEmitter: Error in wildcard listener:', error)
      }
    })
  }

  const off = (eventType, callback) => {
    if (!listeners[eventType]) return

    if (callback) {
      listeners[eventType] = filter(
        listeners[eventType],
        (cb) => cb !== callback
      )
    } else {
      delete listeners[eventType]
    }
  }

  const clear = () => {
    forEach(Object.keys(listeners), (key) => {
      delete listeners[key]
    })
  }

  return { on, emit, off, clear }
}

export default createEventEmitter
